import { render } from "./ModalStaffSignIn.vue?vue&type=template&id=60f0bae9&scoped=true"
import script from "./ModalStaffSignIn.vue?vue&type=script&lang=js"
export * from "./ModalStaffSignIn.vue?vue&type=script&lang=js"

import "./ModalStaffSignIn.vue?vue&type=style&index=0&id=60f0bae9&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f0bae9"]])

export default __exports__